import { useState, useEffect } from "react";
import { useItemStore } from "../../mailitem/mail-item-store";
import { IAttachment } from "../../mailitem/mail-item-types";
import { AttachmentsPresentational } from "./AttachmentsPresentational";
import { isItemAttachment, itemAttachmentFileExtensions } from "../../helpers/ItemAttachmentFileExtensions";

export interface TProps {
  selected: string[];
  setSelected: (selected: string[]) => void;
  saveToContent: React.ReactNode;
}

export const AttachmentsContainer = ({ selected, setSelected, saveToContent }: TProps) => {
  const [attachments, setAttachments] = useState(new Array<IAttachment>());
  const mailItem = useItemStore((s) => s.wrappedMailItem);
  const itemUpdateTs = useItemStore((s) => s.updateTs);

  useEffect(() => {
    const loadAttachments = async () => {
      if (!mailItem) {
        return;
      }

      const attachments = await mailItem.getAttachments();

      if (attachments) {
        const sorted = [...attachments].sort((a, b) => (b?.size || 0) - (a?.size || 0));
        setAttachments(sorted);
      }
    };

    loadAttachments().catch(console.error);
  }, [itemUpdateTs]);

  const toggleSelected = (id: string) => {
    if (selected.includes(id)) {
      setSelected(selected.filter((i) => i !== id));
    } else {
      setSelected([...selected, id]);
    }
  };
  const nonItemAttachments = (x: IAttachment) => !isItemAttachment(x);
  const allSelected = () => selected.length === attachments.filter(nonItemAttachments).length;

  const toggleAll = () => {
    if (allSelected()) {
      setSelected([]);
    } else {
      setSelected(attachments.filter(nonItemAttachments).map((a) => a.id));
    }
  };

  return (
    <AttachmentsPresentational
      saveToContent={saveToContent}
      attachments={attachments}
      toggleSelected={toggleSelected}
      toggleAll={toggleAll}
      allSelected={allSelected()}
      selectedIds={selected}
    />
  );
};
